if (typeof BogoDrawer === 'undefined') {
  class BogoDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      BogoDrawer.bindGlobalEvents();
    }

    static bindGlobalEvents() {
      if (BogoDrawer.eventsBound) return;
      BogoDrawer.eventsBound = true;

      document.addEventListener('click', function (event) {
        const closeButton = event.target.closest('[data-bogo-drawer-close-btn]');
        const closeOverlay = event.target.closest('[data-bogo-drawer-close-overlay]');

        if (closeButton || closeOverlay) {
          event.preventDefault();
          BogoDrawer.closeDrawer(BogoDrawer.getActiveDrawer());
          return;
        }

        const tooltip = event.target.closest('[data-bogo-tooltip]');
        if (!tooltip) return;

        event.preventDefault();
        BogoDrawer.openDrawer(BogoDrawer.getDrawerForTrigger(tooltip), tooltip);
      });

      document.addEventListener('keydown', function (event) {
        const tooltip = event.target.closest('[data-bogo-tooltip]');

        if (tooltip && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          BogoDrawer.openDrawer(BogoDrawer.getDrawerForTrigger(tooltip), tooltip);
          return;
        }

        if (event.key === 'Escape') {
          BogoDrawer.closeDrawer(BogoDrawer.getActiveDrawer());
        }
      });
    }

    static getSharedDrawer() {
      return document.querySelector('[data-bogo-shared-drawer] [data-bogo-drawer]');
    }

    static getDrawerForTrigger(trigger) {
      const localRoot = trigger.closest('bogo-drawer');
      const localDrawer = localRoot ? localRoot.querySelector('[data-bogo-drawer]') : null;

      return localDrawer || BogoDrawer.getSharedDrawer();
    }

    static getActiveDrawer() {
      return document.querySelector('[data-bogo-drawer].is-active');
    }

    static setTriggerState(trigger, expanded) {
      if (!trigger) return;
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    static openDrawer(drawer, trigger) {
      if (!drawer) return;

      const activeDrawer = BogoDrawer.getActiveDrawer();
      if (activeDrawer && activeDrawer !== drawer) {
        BogoDrawer.closeDrawer(activeDrawer);
      }

      drawer.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.__bogoTrigger = trigger || null;
      BogoDrawer.setTriggerState(trigger, true);
      document.body.style.overflow = 'hidden';
    }

    static closeDrawer(drawer) {
      if (!drawer) return;

      drawer.classList.remove('is-active');
      drawer.setAttribute('aria-hidden', 'true');
      BogoDrawer.setTriggerState(drawer.__bogoTrigger, false);
      drawer.__bogoTrigger = null;
      document.body.style.overflow = '';
    }
  }

  BogoDrawer.eventsBound = false;

  if (!customElements.get('bogo-drawer')) {
    customElements.define('bogo-drawer', BogoDrawer);
  }
}
